import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=6c5a183e&"
import script from "./SettingsModal.vue?vue&type=script&lang=js&"
export * from "./SettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&id=6c5a183e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports